import React from 'react'
import Container from 'js/pages/LandingPages/components/Container'
import { FeatureImage, FeatureImageType } from 'js/components/FeatureImage'
import { SharedSectionProps } from './types'

type Props = {
  title: string | null
  image: {
    responsiveImage: FeatureImageType
  } | null
  steps: {
    text: string | null
    image: {
      responsiveImage: FeatureImageType
    } | null
  }[]
} & SharedSectionProps

const HowItWorks = ({ title, image, steps }: Props) => {
  return (
    <section className="pt-[52px] md:pt-96">
      <Container>
        <div className="grid auto-rows-auto gap-x-[40px] lg:grid-cols-2 lg:grid-rows-1">
          <FeatureImage
            image={image?.responsiveImage as FeatureImageType}
            className="top-0 mx-auto lg:sticky lg:pt-24"
          />
          <div>
            <h2 className="quincy pb-28 pt-56 text-32 leading-37 lg:pb-[62px] lg:pt-86 lg:text-48 lg:leading-52">
              {title}
            </h2>
            {steps.map((item, index) => (
              <div className="flex pb-40" key={index}>
                <div className="quincy mr-16 text-40 leading-44">
                  {index + 1}.
                </div>
                <div>
                  <FeatureImage
                    image={item.image?.responsiveImage as FeatureImageType}
                    className="rounded-4"
                  />
                  <p className="pt-10 text-14 font-semiregular leading-19 lg:text-17 lg:leading-21">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  )
}

export default HowItWorks
